import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import PartnerManagementPage from "@/pages/admin/PartnerManagementPage";
export const Route = createFileRoute("/_admin/admin/partner-accounts")({
  head: () =>
    pageHead(
      "Partner Accounts",
      "Manage AKIVA Partner companies, user invitations and scoped work access.",
      "/admin/partner-accounts",
      true,
    ),
  component: PartnerManagementPage,
});
